import request from '@/utils/request'

// 获取鼓励弹窗
export function queryEncouragement(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/queryIsPopUp',
    method: 'get',
    params: { sceneType: 1 }
  })
}
